import React from 'react';

import { SmartDownloadIconProps } from '../../types';
import AppleIcon from './AppleIcon';
import DownloadIcon from './DownloadIcon';
import WindowsIcon from './WindowsIcon';

/**
 * 智能下载图标组件
 * 根据推荐的系统类型自动显示对应的系统图标
 * - Apple Silicon/Intel Mac: 显示 Apple 图标
 * - Windows: 显示 Windows 图标
 * - 其他或无法检测: 显示通用下载图标
 */
const SmartDownloadIcon: React.FC<SmartDownloadIconProps> = ({
  width = 20,
  height = 20,
  color = '#000000',
  className,
  recommendedType,
}) => {
  // 根据推荐类型选择合适的图标
  const getIcon = () => {
    switch (recommendedType) {
      case 'apple':
      case 'intel':
        // Mac 系统（Apple Silicon 或 Intel）显示 Apple 图标
        return (
          <AppleIcon
            width={width}
            height={height}
            color={color}
            className={className}
          />
        );
      case 'windows':
        // Windows 系统显示 Windows 图标
        return (
          <WindowsIcon
            width={width}
            height={height}
            color={color}
            className={className}
          />
        );
      default:
        // 默认或无法检测系统时显示通用下载图标
        return (
          <DownloadIcon
            width={width}
            height={height}
            color={color}
            className={className}
          />
        );
    }
  };

  return getIcon();
};

export default SmartDownloadIcon;
